import './styles.css';
import {Link, useNavigate} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faList, faPlus, faRightFromBracket} from "@fortawesome/free-solid-svg-icons";
import {logout} from "../../pages/Login/functions";

const ReporterSideBar = ({collapsed}) => {

    return (
        <nav id="sidebar" className={`sidebar js-sidebar ${collapsed ? "collapsed" : ""}`}>
            <div className="sidebar-content js-simplebar">
                <a className="sidebar-brand" href="index.html">
                    <span className="align-middle">AdminKit</span>
                </a>

                <ul className="sidebar-nav">


                    <li className="sidebar-header">
                        دسته بندی خبرها
                    </li>
                    <li className="sidebar-item">
                        <Link to={"./newsCategories"} className={"sidebar-link"}>
                            <FontAwesomeIcon className={'ms-2'} icon={faList}/>
                            <span className="align-middle">لیست</span>
                        </Link>
                    </li>

                    <li className="sidebar-item">
                        <Link to={"./newsCategories/add"} className={"sidebar-link"}>
                            <FontAwesomeIcon className={'ms-2'} icon={faPlus}/>
                            <span className="align-middle">افزودن</span>
                        </Link>
                    </li>


                    <li className="sidebar-header">
                        خبرها
                    </li>
                    <li className="sidebar-item">
                        <Link to={"./news"} className={"sidebar-link"}>
                            <FontAwesomeIcon className={'ms-2'} icon={faList}/>
                            <span className="align-middle">لیست</span>
                        </Link>
                    </li>

                    <li className="sidebar-item">
                        <Link to={"./news/add"} className={"sidebar-link"}>
                            <FontAwesomeIcon className={'ms-2'} icon={faPlus}/>
                            <span className="align-middle">افزودن</span>
                        </Link>
                    </li>

                    <li className="sidebar-header">
                        کامنت ها
                    </li>
                    <li className="sidebar-item">
                        <Link to={"./comments"} className={"sidebar-link"}>
                            <FontAwesomeIcon className={'ms-2'} icon={faList}/>
                            <span className="align-middle">لیست</span>
                        </Link>
                    </li>




                    <li className="sidebar-item mt-4">
                        <Link className={"sidebar-link"} onClick={() => {
                            logout();
                            window.location.reload();
                        }}>
                            <FontAwesomeIcon className={'ms-2'} icon={faRightFromBracket}/>
                            <span className="align-middle">خروج</span>
                        </Link>
                    </li>


                </ul>

            </div>
        </nav>
    );
};

export default ReporterSideBar;